import React, { useState } from "react";

const UserActivity = () => {
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [creditAmount, setCreditAmount] = useState("");
    const [existingEmail, setExistingEmail] = useState("");
    const [existingCreditAmount, setExistingCreditAmount] = useState("");
    const [message, setMessage] = useState("");

    const handleCreateCustomer = async () => {
        if (!email.trim() || !firstName.trim() || !lastName.trim()) {
            setMessage("Please fill in all fields to create a customer.");
            console.error("Validation failed: Missing required fields for customer creation.");
            return;
        }

        try {
            console.log("Starting customer creation...");
            const response = await fetch(
                "https://bymolive-backend-995926394015.us-central1.run.app/api/create-customer",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email, first_name: firstName, last_name: lastName }),
                }
            );

            if (!response.ok) {
                const error = await response.json();
                setMessage(`Error creating customer: ${error.error}`);
                console.error("Customer creation failed:", error);
                return;
            }

            const data = await response.json();
            setMessage("Customer created successfully!");
            console.log("Customer created successfully:", data);
        } catch (err) {
            setMessage("Failed to create customer. Please try again.");
            console.error("Error in handleCreateCustomer:", err);
        }
    };

    const handleAddStoreCredit = async () => {
        if (!existingEmail.trim() || !existingCreditAmount) {
            setMessage("Please fill in all fields to add store credit.");
            console.error("Validation failed: Missing required fields for adding store credit.");
            return;
        }

        try {
            console.log("Fetching customer ID for email:", existingEmail);

            // Step 1: Fetch customer_id using the email
            const customerResponse = await fetch(
                "https://bymolive-backend-995926394015.us-central1.run.app/api/get-customer-id",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email: existingEmail }),
                }
            );

            if (!customerResponse.ok) {
                const error = await customerResponse.json();
                setMessage(`Error fetching customer ID: ${error.error}`);
                console.error("Customer ID fetch failed:", error);
                return;
            }

            const customerData = await customerResponse.json();
            const customerId = customerData.customer_id;
            console.log("Customer ID fetched successfully:", customerId);

            // Step 2: Add store credit
            console.log("Starting store credit addition...");
            const creditResponse = await fetch(
                "https://bymolive-backend-995926394015.us-central1.run.app/api/add-store-credit",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        customer_id: customerId,
                        credit_amount: parseFloat(existingCreditAmount),
                    }),
                }
            );

            if (!creditResponse.ok) {
                const error = await creditResponse.json();
                setMessage(`Error adding store credit: ${error.error}`);
                console.error("Store credit addition failed:", error);
                return;
            }

            const creditData = await creditResponse.json();
            setMessage("Store credit added successfully!");
            console.log("Store credit added successfully:", creditData);
        } catch (err) {
            setMessage("Failed to add store credit. Please try again.");
            console.error("Error in handleAddStoreCredit:", err);
        }
    };


    return (
        <div>
            <h1>User Account & Credits in Shopify</h1>

            {/* Section for creating a customer */}
            <div style={{ marginTop: "20px" }}>
                <h2>Create Customer</h2>
                <input
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                        padding: "10px",
                        width: "300px",
                        marginBottom: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                    }}
                />
                <input
                    type="text"
                    placeholder="Enter first name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    style={{
                        padding: "10px",
                        width: "300px",
                        marginBottom: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        marginLeft: "10px",
                    }}
                />
                <input
                    type="text"
                    placeholder="Enter last name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    style={{
                        padding: "10px",
                        width: "300px",
                        marginBottom: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        marginLeft: "10px",
                    }}
                />
                <button
                    onClick={handleCreateCustomer}
                    style={{
                        padding: "10px 20px",
                        marginLeft: "10px",
                        backgroundColor: "#28a745",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    Create Customer
                </button>
            </div>

            {/* Section for adding store credit */}
            <div style={{ marginTop: "40px" }}>
                <h2>Add Store Credit</h2>
                <input
                    type="email"
                    placeholder="Enter customer email"
                    value={existingEmail}
                    onChange={(e) => setExistingEmail(e.target.value)}
                    style={{
                        padding: "10px",
                        width: "300px",
                        marginBottom: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                    }}
                />
                <input
                    type="number"
                    placeholder="Enter credit amount"
                    value={existingCreditAmount}
                    onChange={(e) => setExistingCreditAmount(e.target.value)}
                    style={{
                        padding: "10px",
                        width: "300px",
                        marginBottom: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        marginLeft: "10px",
                    }}
                />
                <button
                    onClick={handleAddStoreCredit}
                    style={{
                        padding: "10px 20px",
                        marginLeft: "10px",
                        backgroundColor: "#007bff",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    Add Store Credit
                </button>
            </div>

            {/* Message display */}
            {message && (
                <p
                    style={{
                        marginTop: "20px",
                        color: message.includes("successfully") ? "green" : "red",
                    }}
                >
                    {message}
                </p>
            )}
        </div>
    );
};

export default UserActivity;
